<template>
    <div>
        <compFormEdit ref="accountform" class="margin-top-15" :formdata="getBase" v-model="formData" :col="1"></compFormEdit>
        <div class="text-right">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpCarrierCheckAccount,HttpCreateDownLoad, HttpGetCarrierAccount } from '@/service/costbilling';
export default {
    data(){
        return{
            formData:{},
            accountList:[],
        }
    },
    computed:{
        ...mapGetters('dictionary', [ 'getCarrierAllList', 'getCountryList']),
        getBase(){
            return [
                {
                    label: this.$t('ucadm.notice.task',{defaultValue:'任务'})+this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                    tag:'vSelect',
                    key:'type',
                    options:[
                        {label:'账单任务下载',value:0},
                        {label:'燃油费任务下载',value:1},
                        {label:'POD下载',value:3},
                    ]
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'vSelect',
                    key: 'carrierCode',
                    options:this.formData.type == 0 ? [
                        {label:'FedEx',value:'FedEx'},
                        {label:'UPS',value:'UPS'}
                    ]: this.formData.type == 1 ?[
                        {label:'FedEx',value:'FedEx'},
                        {label:'FedEx Freight',value:'FedEx Freight'},
                        {label:'UPS',value:'UPS'}
                    ]: [
                        {label:'FedEx',value:'FedEx'},
                    ],
                    props:{
                        filterable:true,
                    },
                    on:{
                        'on-change':(val)=>{
                            this.getAccountList(val)
                        }
                    }
                },
                {
                    label:'账户',
                    tag: 'vSelect',
                    key: 'accountId',
                    show:this.formData.type!=1,
                    options: this.accountList.map(item=>{
                        return {
                            value: item.id,
                            label: item.accountNumber
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    required: this.formData.type == 3 ?  true : false,
                },
                {
                    label:'发票日期',
                    tag: 'vDatepicker',
                    key: 'invoiceStartDate',
                    show:this.formData.type != 1 && this.formData.type != 3,
                    props: {
                        format: 'yy-mm-dd~yy-mm-dd',
                        confirm: false,
                    },

                },
                {
                    label:'国别',
                    tag: 'vSelect',
                    key: 'country',
                    options: [
                        {value: 'US', label: 'US'},
                        {value: 'CA', label: 'CA'},
                    ],
                    show:this.formData.type == 1,
                },
                {
                    label:'Tracking',
                    tag: 'Input',
                    key: 'trackingNos',
                    show:this.formData.type == 3,
                    formItem: {
                      tip: this.type != 'query' ? "<div class=color-error>请输入Tracking，使用英文逗号隔开</div>" : '',
                    }
                }
            ]
        }
    },
    methods:{
        getAccountList(val){
            HttpGetCarrierAccount({
            // HttpCarrierCheckAccount({
                carrierCode:val,
                // active:0,
                // id:this.id || '',
            }).then(res=>{
                this.accountList = res.data
            })
        },
        async submit(){
            let date = []
            if(this.formData.type==0){
                date = this.formData.invoiceStartDate.split('~')
            }
            if(this.formData.trackingNos){
                const reg=new RegExp("，","g")
                let trackingNoList = this.formData.trackingNos.replace(reg ,',').split(',');
                this.formData.trackingNos = trackingNoList.filter(item=>item.length >0)
            }
            HttpCreateDownLoad({
                type:this.formData.type,
                carrierCode:this.formData.carrierCode||'',
                accountId:this.formData.accountId||'',
                trackingNos: this.formData.trackingNos || [],
                invoiceStartDate:date[0]||'',
                invoiceEndDate:date[1]||'',
                country: this.formData.country || ''
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel();
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>
